module.exports = __webpack_public_path__ + "img/9791158882617.32ad5850.jpg";